import { useFtpStore } from '../../store/ftpStore';

/**
 * The connection and remote folder a transfer was DECIDED for. A batch asks its
 * questions (and a folder upload streams its files) over seconds or minutes;
 * switching to another connected server meanwhile must not send the rest there
 * — into a folder that was never checked for clashes. Falls back to the active
 * connection / pane for a caller that pinned nothing.
 */
export function pinnedConn(meta, s) {
  return meta?.connId || s.activeConnId;
}

/** A queued folder-upload row whose start returned without taking it over
 *  (not connected any more, file unreadable) must not say "Queued" forever. */
export function settleIfStillQueued(transferId, patch) {
  if (!transferId) return;
  const row = useFtpStore.getState().transfers.find((tr) => tr.transferId === transferId);
  if (!row || !row.queued || row.done) return;
  useFtpStore.getState().upsertTransfer({ transferId, queued: false, done: true, ...patch });
}
